import React from 'react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel,
  AlertDialogContent, AlertDialogDescription, AlertDialogFooter,
  AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { Trash2 } from 'lucide-react';

/**
 * Reusable delete confirmation dialog.
 * Usage:
 *   <ConfirmDeleteDialog onConfirm={() => handleDelete(id)} />
 * or with custom trigger:
 *   <ConfirmDeleteDialog trigger={<Button>Delete</Button>} onConfirm={...} />
 */
const ConfirmDeleteDialog = ({
  onConfirm,
  title = 'Silmek istediğinizden emin misiniz?',
  description = 'Bu işlem geri alınamaz.',
  trigger,
  testId,
}) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>
      {trigger || (
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8 text-muted-foreground hover:text-destructive"
          data-testid={testId}
        >
          <Trash2 size={14} />
        </Button>
      )}
    </AlertDialogTrigger>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>{title}</AlertDialogTitle>
        <AlertDialogDescription>{description}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>İptal</AlertDialogCancel>
        <AlertDialogAction
          className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          onClick={onConfirm}
          data-testid="confirm-delete-btn"
        >
          Sil
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export default ConfirmDeleteDialog;
